import {Component, Input, OnInit} from '@angular/core';
import {SolutionEvent} from '../../../../../../../../domain/event/solution-event';
import {WidgetDetail} from '../../../../../../../../domain/widget/model/widget-detail';
import {UserContextService} from '../../../../../../../../application/app-context/user-context/user-context.service';
import {UserContext} from '../../../../../../../../application/app-context/user-context/user-context';
import {DomainUrlService} from '../../../../../../../../application/config/domain-url.service';
import {AgendaSubjectEventService} from '../../../../../../../../domain/agenda/service/agenda-subject-event.service';
import {WidgetService} from '../../../../../../../../domain/widget/service/widget.service';
import {AmplitudeService} from '../../../../../../../../application/analytics/service/amplitude.service';
import {EventLight} from '../../../../../../../../domain/event/event-light';

@Component({
             selector: 'app-widget-event-latest-event-xlarge',
             templateUrl: './home-dashboard-widget-event-latest-events-xlarge.component.html',
             styleUrls: ['./home-dashboard-widget-event-latest-events-xlarge.component.scss']
           })
export class HomeDashboardWidgetEventLatestEventsXlargeComponent implements OnInit {

  readonly TRACK_EVENT_ALL_EVENT_LABEL = 'Widget_Events_DisplayAllEvents';
  readonly TRACK_EVENT_SUBSCRIBE_LABEL = ' Widget_Events_Subscribe';

  @Input() widget: WidgetDetail;
  @Input() solutionEvents: Array<SolutionEvent>;
  @Input() isMocked: boolean;

  currentSolutionEvent: SolutionEvent;
  userContext: UserContext;
  latestEventUrl: string;

  constructor(private userContextService: UserContextService,
              private domainUrlService: DomainUrlService,
              private agendaSubjectEvent: AgendaSubjectEventService,
              private widgetService: WidgetService,
              private amplitudeService: AmplitudeService) {
  }

  ngOnInit(): void {
    this.userContext = this.userContextService.getUserContext();
    this.latestEventUrl = this.domainUrlService.getPublicationUrl().concat('/finances_locales/evenements');
    this.agendaSubjectEvent.onChangeEvents.subscribe(() => this.updateEventsBySolutions());

    if (this.solutionEvents.length > 0) {
      this.currentSolutionEvent = this.solutionEvents[0];

    }
  }

  previousSolutionEvents() {
    this.currentSolutionEvent = this.solutionEvents[this.solutionEvents.indexOf(this.currentSolutionEvent) - 1];
  }

  nextSolutionEvents() {
    this.currentSolutionEvent = this.solutionEvents[this.solutionEvents.indexOf(this.currentSolutionEvent) + 1];
  }

  isLastSolutionEvents(): boolean {
    return this.solutionEvents.indexOf(this.currentSolutionEvent) === this.solutionEvents.length - 1;
  }

  isFirstSolutionEvents(): boolean {
    return this.solutionEvents.indexOf(this.currentSolutionEvent) === 0;
  }

  private updateEventsBySolutions() {
    this.widgetService.retrieveWidgetData(this.widget.widgetName, this.widget.size, this.isMocked)
        .subscribe((solutionsEvent: Array<SolutionEvent>) => {
          this.currentSolutionEvent = this.isAlreadyOnSolutionsDisplaysOrMultipleCategorie(solutionsEvent, this.solutionEvents)
                                      ? solutionsEvent.find(solution => solution.eventSolutionName
                                                                        === this.currentSolutionEvent.eventSolutionName)
                                      : solutionsEvent[0];
          this.solutionEvents = solutionsEvent;
        });
  }

  private isAlreadyOnSolutionsDisplaysOrMultipleCategorie(solutionsEvent: Array<SolutionEvent>, oldSolutionsEvents: Array<SolutionEvent>) {
    return solutionsEvent.find(solution => solution.eventSolutionName === this.currentSolutionEvent?.eventSolutionName)
           && (oldSolutionsEvents.length !== 1);
  }

  onTrackEventSubscribeAction(eventLight: EventLight) {
    const eventProperties = new Map<string, string>();
    eventProperties.set('Event Solution', eventLight.theme);
    eventProperties.set('Event Catégorie', eventLight.category);
    eventProperties.set('Event Name', eventLight.title);
    eventProperties.set('Event Date', eventLight.eventDate);
    eventProperties.set('Event Important', eventLight.focus ? 'Oui' : 'NON');
    this.amplitudeService.trackEventProperties(this.TRACK_EVENT_SUBSCRIBE_LABEL, eventProperties);
  }

  onTrackAllEventAction() {
    const eventProperties = new Map<string, string>();
    this.amplitudeService.trackEventProperties(this.TRACK_EVENT_ALL_EVENT_LABEL, eventProperties);
  }
}
